import axios from "axios";

// Create the axios instance
const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
    },
});

// Added a response interceptor
api.interceptors.response.use(
    (response) => response, // if it successful, let if pass
    (error) => {
        if (error.response?.status === 401) {
            // if token is expired
            alert("Session expired !, Please login again");
            localStorage.removeItem("loginDetail");
            window.location.href = "/login";
        }
        // Returned a rejected promise for further handling if needed
        return Promise.reject(error);
    }
);

export default api;
